import BaseFileSystemService from "./filesystem.base.service";
import { injectable, inject } from "inversify";

@injectable()
export default class NumberProviderService {
    alpha = "_ABCDEFGHIJKLMNOPQRSTUVWXYZ";

    getNumber = (value: number) => {
        let remainder = value;

        let result = "";

        do {
            result = this.alpha[remainder % this.alpha.length] + result;
            remainder = parseInt("" + remainder / this.alpha.length);
        } while (remainder > 0);

        return result;
    };
}



// WEBPACK FOOTER //
// ./src/services/number_provider.ts